import { Yup } from 'app/components/core/Form';

const PROPERTY_LINE_REGEX = /\w+=\w*$|^$/;

export const PropertiesObject = Yup.string().matches(
    PROPERTY_LINE_REGEX,
    'forms:common.fields.properties.validation'
);

export const SnowflakeSchemaFqnObject = Yup.object({
    database: Yup.string().required(),
    schema: Yup.string().required()
});

export const SnowflakeFileFormatFqnObject = Yup.object({
    database: Yup.string().required(),
    schema: Yup.string().required(),
    fileFormat: Yup.string().required()
});

export const SnowflakeStageFqnObject = Yup.object({
    database: Yup.string().required(),
    schema: Yup.string().required(),
    stage: Yup.string().required()
});

export const SnowflakeTableFqnObject = Yup.object({
    database: Yup.string().required(),
    schema: Yup.string().required(),
    table: Yup.string().required()
});
